/**
 * Variant live refresh
 * Keeps text and image blocks in the product section in sync with the selected
 * variant. Blocks connected to variant metafields (dynamic sources) re-render
 * whenever the shopper changes an option (e.g. Shape).
 */
const BLOCK_CLASS = /^(?:image|text)-block--(?!height-|align-)[\w-]*_[\w-]*$/;

function blockKey(el) {
  for (const c of el.classList) {
    if (BLOCK_CLASS.test(c)) return c;
  }
  return null;
}

document.addEventListener('variant:update', (event) => {
  const html = event.detail?.data?.html;
  const target = event.target instanceof Element ? event.target : null;
  const section = target?.closest('.shopify-section');
  if (!html || !section || !section.id) return;

  const freshSection = html.getElementById(section.id);
  if (!freshSection) return;

  section.querySelectorAll('.image-block, .text-block').forEach((el) => {
    const key = blockKey(el);
    if (!key) return;
    const fresh = freshSection.querySelector('.' + CSS.escape(key));
    if (fresh && fresh.innerHTML !== el.innerHTML) {
      el.innerHTML = fresh.innerHTML;
    }
  });

  section.querySelectorAll('[data-variant-refresh]').forEach((el) => {
    const fresh = freshSection.querySelector(
      `[data-variant-refresh="${CSS.escape(el.dataset.variantRefresh)}"]`
    );
    if (fresh && fresh.innerHTML !== el.innerHTML) {
      el.innerHTML = fresh.innerHTML;
    }
  });
});
